import { useState } from "react"
import "./styles.css"
import "../../fonts.css"
import { IoIosSearch } from "react-icons/io"
import { FiMenu } from "react-icons/fi"
import Mock from "./Mock"
import Info from "./Info"
import Loader from "../../components/Loader"
import { BiErrorCircle } from "react-icons/bi"
import useMusics from "../../utils/mocks/musics/useMusics"
import Layout from "../../components/Layout"

const MusicasSugeridas = () => {
  const [search, setSearch] = useState("")
  const { data, loading, error } = useMusics()

  return (
    <Layout
      title="Músicas"
      titleColor="#6184FE"
      hasBackground={false}
      description=""
      children={
        <div className="container">
          <div className="search-container">
            <input
              placeholder="Busca"
              type="text"
              className="search-field"
              onChange={(event) => setSearch(event.target.value)}
            />
            <IoIosSearch color="rgba(0, 0, 0, 0.8)" />
          </div>
          {loading ? (
            <div className="white-box-content" style={{ padding: "20px" }}>
              <Loader size={40} />
            </div>
          ) : data ? (
            data
              .filter((localData) => {
                return search.toLocaleLowerCase() === ""
                  ? localData
                  : localData?.name
                      .toLocaleLowerCase()
                      .includes(search.toLocaleLowerCase())
              })
              .map((localData) => {
                return (
                  <Info
                    key={localData.id}
                    name={localData.name}
                    author_name={localData.author_name}
                    image_link={localData.image_link}
                    spotifyLink={localData.spotify_link}
                    youtubeLink={localData.youtube_link}
                  />
                )
              })
          ) : null}

          {error ? (
            <div className="white-box-content" style={{ padding: "20px" }}>
              <BiErrorCircle /> Houve um erro ao processar sua solicitação.
            </div>
          ) : null}
        </div>
      }
      backButton="/sugestoes"
    />
  )
}

export default MusicasSugeridas
